import React, { useState } from 'react';
import './ConductorForm.css';

const conductorTypes = [
  { value: 'overhead-conductor', label: 'Overhead Conductor' },
  { value: 'underground-conductor', label: 'Underground Conductor' },
  { value: 'overhead-service', label: 'Overhead Service' },
  { value: 'underground-service', label: 'Underground Service' }
];

const ConductorForm = ({ onSubmit, onClose, length }) => {
  const [formData, setFormData] = useState({
    type: '',
    wireSize: '',
    length: length.toFixed(2),
    notes: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="conductor-form-container">
      <div className="conductor-form-content">
        <div className="conductor-form-header">
          <h2>Add Conductor</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="type">Conductor Type</label>
            <select
              id="type"
              value={formData.type}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              required
            >
              <option value="">Select Conductor Type</option>
              {conductorTypes.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
          <div className="form-field">
            <label htmlFor="wireSize">Wire Size</label>
            <input
              type="text"
              id="wireSize"
              value={formData.wireSize}
              onChange={(e) => setFormData({ ...formData, wireSize: e.target.value })}
              placeholder="e.g., 4/0, 350MCM"
              required
            />
          </div>
          <div className="form-field">
            <label htmlFor="length">Length (ft)</label>
            <input
              type="number"
              id="length"
              value={formData.length}
              onChange={(e) => setFormData({ ...formData, length: e.target.value })}
              step="0.01"
              required
            />
          </div>
          <div className="form-field">
            <label htmlFor="notes">Notes</label>
            <textarea
              id="notes"
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              placeholder="Add any additional notes here..."
              rows={4}
            />
          </div>
          <div className="form-actions">
            <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
            <button type="submit" className="submit-button">Add Conductor</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConductorForm; 